export class DettagliTransazione {
  listaDettaglioTransazioneId: number[] = [];
}
